export enum PDFViewerStateEnum {
    Loaded = 1,
    Failed = 2,
    NoPDF = 3
}